/**
 * Entidad Media
 * Se utiliza para almacenar y gestionar archivos y recursos multimedia.
 */

export interface Media {
  id: string;
  accountId: string;
  filename: string;
  url: string;
  thumbnailUrl: string;
  mimeType: string;
  extension: string;
  size: number;
  type: MediaType;
  altText: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date | null;
}

export enum MediaType {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
  FAVICON = 'FAVICON',
  DOCUMENT = 'DOCUMENT',
  AUDIO = 'AUDIO',
  ARCHIVE = 'ARCHIVE',
  OTHER = 'OTHER',
}


